// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K0RPWYloLlzdV9_dcV8l{height:40px}.BzbtIGK79kM7dYVOLyvr{padding:12px}.RJAOA0EBr4m6wERb194V{background-color:var(--gray-a-15);border-radius:8px;justify-content:center;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submitButton": `K0RPWYloLlzdV9_dcV8l`,
	"textField": `BzbtIGK79kM7dYVOLyvr`,
	"iconWrapper": `RJAOA0EBr4m6wERb194V`
};
export default ___CSS_LOADER_EXPORT___;
